export enum ShareWorkspaceDialogSections {
  SHARE = "share",
  PERMISSION = "permission",
  INFO = "info",
  EVERY = "every",
}
